import { Controller } from "@hotwired/stimulus"

// A listing on no figure (listings/_inbox_listing): each "Same as a figure
// here?" row's Link says what it files the listing under, as its option box
// changes ("Link as its Deluxe"), and every Link how many other stores
// ticked below go along ("+2 stores").
export default class extends Controller {
  connect() { this.update() }

  update() {
    this.element.querySelectorAll("select[data-link-for]").forEach(select => {
      const said = this.element.querySelector(`[data-link-button='${select.dataset.linkFor}'] [data-link-said]`)
      if (said) said.textContent = ` ${select.selectedOptions[0]?.dataset.said || ""}`.trimEnd()
    })
    const n = this.element.querySelectorAll("input[name='also_link_ids[]']:checked").length
    this.element.querySelectorAll("[data-also-count]").forEach(span => { span.textContent = n ? ` +${n} ${n === 1 ? "store" : "stores"}` : "" })
  }
}
